import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import Swiper from 'swiper/bundle';
import { Router } from '@angular/router';
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    CommonModule,
  ImageGalleryComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements AfterViewInit,OnInit {

  public swiper!: Swiper;
  public images: string[]=[]
  public clientImages!: { image: string, routeLink: string }[];
  public aimMission: string[]=[]

  constructor(private router: Router) {}
  
  ngOnInit(): void {
    this.getProductImage();
    this.getClientImgages();
    this.missionContext();
  }

  ngAfterViewInit(): void {
    this.swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 5000, // 5 second between slides
      },
    });
  }

  public getProductImage(){
    this.images = [
      "../../assets/lego-machine.jpg",
      "../../assets/machine2.jpg",
      "../../assets/machine3.jpeg",
    ]
  }

  public missionContext():void {

    this.aimMission = [
      "<strong>Deliver Precision Without Compromise</strong> – Produce high-tolerance plastic components that meet or exceed client specifications.",
      "<strong>Scale With Agility</strong> – Offer flexible, high-capacity production runs that adapt to evolving market demands",
      "<strong>Add Value Beyond Molding</strong> – Integrate assembly, packaging, and logistics into a seamless manufacturing solution.",
      "<strong>Drive Innovation in Manufacturing</strong> – Continuously invest in technology, automation, and process excellence.",
      "<strong>Build Enduring Partnerships</strong> – Commit to transparency, reliability, and long-term customer success."
    ]
  }

  public getClientImgages(){
    this.clientImages = [
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
    ]
    
  }

  public goToClient(): void {
    this.router.navigate(['/client']);
  }

}
